import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../store';
import Interview, { IDispatchProps, IProps } from './index';
import { Status } from '../../../atoms/finger-with-action';
import { resetPCIQuestions } from '../../../../store/student/preCasInterview/actions';
import { savePreCasInterview, updateRisks } from '../../../../store/student/actions';
import { Pages } from '../../../../store/student/preCasInterview/types';
import { PCI1Risk, PCI2Risk, PCI3Risk, PCI4Risk } from '../../../../store/student/risks/reducer';

interface OwnProps {
  id: any;
}

export const mapStateToProps = (state: ApplicationState): IProps => {
  const PCI1Complete =
    state.student.preCasInterview && state.student.preCasInterview.isPage1Complete
      ? state.student.preCasInterview.isPage1Complete
      : false;
  const PCI2Complete =
    state.student.preCasInterview && state.student.preCasInterview.isPage2Complete
      ? state.student.preCasInterview.isPage2Complete
      : false;
  const PCI3Complete =
    state.student.preCasInterview && state.student.preCasInterview.isPage3Complete
      ? state.student.preCasInterview.isPage3Complete
      : false;
  const PCI4Complete =
    state.student.preCasInterview && state.student.preCasInterview.isPage4Complete
      ? state.student.preCasInterview.isPage4Complete
      : false;
  return {
    ...state.student.preCasInterview,
    hasStarted: !(PCI1Complete === false && PCI2Complete === false && PCI3Complete === false && PCI4Complete === false),
    complete: PCI1Complete && PCI2Complete && PCI3Complete && PCI4Complete,
    PCI1: PCI1Risk(state.student.risks, state.auth.role)
      ? Status.AtRisk
      : state.student.preCasInterview.isPage1Complete
        ? Status.Complete
        : Status.Todo,
    PCI2: PCI2Risk(state.student.risks, state.auth.role)
      ? Status.AtRisk
      : state.student.preCasInterview.isPage2Complete
        ? Status.Complete
        : Status.Todo,
    PCI3: PCI3Risk(state.student.risks, state.auth.role)
      ? Status.AtRisk
      : state.student.preCasInterview.isPage3Complete
        ? Status.Complete
        : Status.Todo,
    PCI4: PCI4Risk(state.student.risks, state.auth.role)
      ? Status.AtRisk
      : state.student.preCasInterview.isPage4Complete
        ? Status.Complete
        : Status.Todo,
    riskList: state.student.risks.preCasInterviewRisk,
    clearedRisks: state.student.risks.clearedRisks.preCasInterviewRisk,
    userRole: state.auth.role,
  };
};

// eslint-disable-next-line no-empty-pattern
function mapDispatchToProps(dispatch: Dispatch, {}: OwnProps): IDispatchProps {
  return {
    onUpdateRisks: (source: string, clearedRisks: any) => dispatch(updateRisks({ source, clearedRisks })),
    onReset: () => {
      dispatch(resetPCIQuestions());
      dispatch(savePreCasInterview(Pages.RESET_INTERVIEW));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Interview);
